import { makeStyles } from '@material-ui/core';
import { colorSet } from '@components/Provider';

export const useSignupStyle = makeStyles((theme) => ({
  mobileNav: {
    width: '100%',
    padding: '16px 20px',
    display: 'flex',
    position: 'relative',
    justifyContent: 'center',
    alignItems: 'center',
    height: 48,
    border: `1px solid ${colorSet.gray400}`,
    '& .arrowBackIcon': {
      position: 'absolute',
      left: 20
    }
  },
  titleSection: {
    marginBottom: 40,
    padding: '0px 16px',
    '& .loginButton': {
      position: 'absolute',
      justifyContent: 'flex-end',
      top: 24,
      right: 32,
      padding: '0px 32px',
      [theme.breakpoints.down('xs')]: {
        padding: '0px 16px'
      },
      '& button': {
        padding: 0,
        '& span': {
          color: colorSet.gray700
        }
      },
      '& .subText': {
        marginRight: 16,
        color: colorSet.gray600
      }
    },
    '& .logoBox': {
      maxWidth: 600,
      position: 'relative',
      marginBottom: 24,
      '& .textBox > p': {
        marginTop: 4,
        color: colorSet.gray600
      },
      '& img': {
        zIndex: 2
      },
      '& img:hover': {
        cursor: 'pointer'
      },
      '& .arrowBackIcon': {
        position: 'absolute',
        left: 0,
        '& svg': {
          fill: colorSet.gray900
        }
      }
    },
    [theme.breakpoints.down('xs')]: {
      marginBottom: 36,
      '& .loginButton': {
        right: 0
      }
    }
  }
}));
